import Overview from './Overview';

const overview =
{
    list: Overview,
};

export default overview;
